import { Table, Typography } from 'antd';

const {Text} = Typography;

interface SummaryRowProps<T> {
  columns: any[];
  summaryData: Partial<Record<keyof T, any>>;
  label?: string;
}

export function SummaryRow<T extends Record<string, any>>({
  columns,
  summaryData,
  label = '总计',
}: SummaryRowProps<T>) {
  const summaryKey = columns.map((c) => c.dataIndex || c.key || '').join('-');

  return (
      <Table.Summary key={summaryKey} fixed={'bottom'}>
        <Table.Summary.Row>
          {columns.map((col, index) => {
            const {dataIndex, align} = col;

            const cellProps = {index, align} as any;

            if (index === 0) {
              return (
                  <Table.Summary.Cell key={index} {...cellProps}>
                    <Text strong>{label}</Text>
                  </Table.Summary.Cell>
              );
            }

            if (!dataIndex) {
              return <Table.Summary.Cell key={index} {...cellProps} />;
            }

            const value = summaryData[dataIndex];

            if (col.summaryRender) {
              return (
                  <Table.Summary.Cell key={index} {...cellProps}>
                    {col.summaryRender(value, summaryData)}
                  </Table.Summary.Cell>
              );
            }

            return (
                <Table.Summary.Cell key={index} {...cellProps}>
                  <Text strong>{value ?? '-'}</Text>
                </Table.Summary.Cell>
            );
          })}
        </Table.Summary.Row>
      </Table.Summary>
  );
}
